import { useContext, useEffect, useState } from 'react'
import moment from 'moment'

import { Modal } from '../ui_new'
import { dateDisplayFormat, documentCommentSections } from '../../utils'
import { Check, Close } from '../../assets/icons'
import { DocumentsContext, SingleDocumentContext } from '../../context'
import { DOCUMENT_STATUS_LABELS } from '../../constants'
import { AddCommentOutlined, Cancel, Notes } from '@mui/icons-material'
import CommentsView from './CommentsView'
import { useAgencyActions } from '../../hooks'

const ValidationSummaryModal = ({ onClose, template }) => {

  const { document, activeValidation } = useContext(SingleDocumentContext)
  const { templates } = useContext(DocumentsContext)
  const { isTemplateValidationRequired } = useAgencyActions()

  const validationStatusColor = activeValidation?.status === 'validated' ? 'green' : activeValidation?.status === 'pending' ? 'gray' : activeValidation?.status === 'refused' ? 'red' : 'gray'
  const validationStatusText = activeValidation?.status === 'validated' ? 'Validé' : activeValidation?.status === 'pending' ? 'À valider' : activeValidation?.status === 'refused' ? 'À corriger' : 'Non validé'
  const statusColor = document?.status === 'ready' ? 'green' : document?.status === 'draft' ? 'gray' : document?.status === 'to_sign' ? 'yellow' : document?.status === 'signed' ? 'green' : 'red'

  const [commentsGeneral, setCommentsGeneral] = useState([])
  const [commentSections, setCommentSections] = useState([])

  useEffect(() => {
    if (!document) return
    const commentSections = documentCommentSections(document, templates[document?.template])
    const commentsGeneral = [...(document.commentsGeneral || [])]
    setCommentsGeneral(commentsGeneral)
    setCommentSections(commentSections)

  }, [document, templates])

  const commentAuthorLabel = (comment, general = false) => {
    let authorName = ''
    if (comment.author && comment.author.firstname && comment.author.lastname) {
      authorName = `${comment.author.firstname} ${comment.author.lastname}`
    }
    let authorType = comment.author?.type === 'negotiator' ? 'négociateur' : comment.author?.type === 'manager' ? 'manager' : comment.author?.type === 'client' ? 'client' : comment.author?.type === 'notary' ? 'notaire' : comment.author?.type === 'lawyer' ? 'avocat' : comment.author?.type === 'external' ? 'externe' : ''
    let label = ''
    if (general) {
      label = `Commentaire général ${authorType}`
    } else {
      label = `${authorName}`
    }
    return label
  }

  return (
    <Modal onClose={onClose} className="modal-v2--no-padding modal-v2--mid-large-2">
      <div className='modal-v2__heading'>
        <div>
          <h2>Mode révision</h2>
        </div>
        <div className="buttons-row">
          <button className="btn btn--with-icon btn--large btn--primary-light" onClick={onClose}><Close /> Fermer</button>
        </div>
      </div>
      <div className="modal-v2__body validation-summary">
        <div className="flex flex-row flex-wrap validation-summary__blocks-container">
          <div className="validation-summary__block">
            <h2>Informations générales du document :</h2>

            <div className='mt-2'>
              <label className="label-title mb-1 pl-1">
                <span className='status-dot'></span>
                Statut de rédaction
              </label>
              <div className="progress-bar progress-bar__with-label">
                <div className="progress-bar__body">
                  <div
                    className="progress-bar__body_progress"
                    style={{
                      width: `${document?.progress * 100}%`,
                    }}
                  ></div>
                </div>
                <div className="progress-bar__label">
                  <span>{`${(document?.progress * 100).toFixed(0)}%`}</span>
                </div>
              </div>
              <div className='flex flex-row items-center justify-start w-full validation-status-label mb-2'>
                <span>
                  <span className={`status-circle ${statusColor}`}></span>{DOCUMENT_STATUS_LABELS[document?.status]}
                </span>
              </div>
              <div className="doc-version">
                <div className="flex gap-4 align-center mb-1">
                  <label className="label-title">
                    <Check />
                    Statut de validation
                  </label>
                </div>
                <div className='flex flex-row items-center justify-between w-full validation-status-label mb-2'>
                  <span>
                    {isTemplateValidationRequired(template?.id) ? 'Obligatoire' : 'Facultatif'}
                  </span>
                  <span>
                    <span className={`status-circle ${validationStatusColor}`}></span>{validationStatusText}
                  </span>
                </div>
              </div>
            </div>
            <CommentsView comments={commentsGeneral} isGeneralComments={true} canAddComment={false} />
          </div>
          {commentSections.length > 0 &&
            <div className="validation-summary__block">
              <h2>Commentaires par section</h2>
              <CommentsView commentSections={commentSections} canAddComment={false} isSummaryView={true} />
            </div>
          }
        </div>
      </div>
    </Modal>
  )
}

export default ValidationSummaryModal
